var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoundOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sound-on_svg__clip0_6229_18997)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 0v24l-9.333-7H0V7h5.667L15 0zm-2 4L6.333 9H2v6h4.333L13 20V4zM17.5 6.986l.707.707c2.39 2.39 2.39 6.124 0 8.514l-.707.707-1.414-1.414.707-.707c1.61-1.61 1.61-4.076 0-5.686l-.707-.707L17.5 6.986z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4 4.286l.707.707c3.89 3.89 3.89 10.224 0 14.114l-.707.707-1.414-1.414.707-.707c3.11-3.11 3.11-8.176 0-11.286l-.707-.707L20.4 4.286z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sound-on_svg__clip0_6229_18997"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgSoundOn;